var pageValues = require('src/interlock/no-ui/page-values/page-values');
var sectsGenerator = require('./ad-sects-generator');
var sitenameGenerator = require('./sitename-generator');
var wtfContextGenerator = require('./wtf-context-generator');

var REGEX_ZONE_SCRUB = /([\$\-\_\+\!\*\'\(\),\" ])/gi;

function _scrubString(str) {
    return str.replace(REGEX_ZONE_SCRUB, '').toLowerCase();
}

function _visitorContext() {
    // todo: get visitor values
    var visitor = pageValues.visitor();
    var pageContextValues = pageValues.values();

    return {
        vid: visitor.id,
        edw: visitor.session + '',
        zip: pageContextValues.region.zipCode + '',
        dma: pageContextValues.region.dma + '',
        st:  pageContextValues.region.state
    };
}

/**
 * Context for page
 * @returns {Object}
 */
function _pageContext() {
    // todo: get vehicle for this page.
    // todo: get other page level data
    // var vehicle = {};
    var SECT10_FIND = 'find';
    var pageContextValues = pageValues.values();
    var timestamp = Date.now() + '';
    var context = {
        edwpg: _pageValuesCheck(pageContextValues.page,'name'),
        edwcat: _pageValuesCheck(pageContextValues.page,'category'),
        ts: _pageValuesCheck(pageContextValues.page,'timestamp', timestamp),
        tsp: _pageValuesCheck(pageContextValues.page,'timestamp', timestamp),
        mk: _scrubString(_pageValuesCheck(pageContextValues.vehicle.make,'niceName')),
        mdl: _scrubString(_pageValuesCheck(pageContextValues.vehicle.model,'niceName')),
        year: _pageValuesCheck(pageContextValues.vehicle.modelYear,'year'),
        sub: _scrubString(_pageValuesCheck(pageContextValues.vehicle.subModel,'name')),
        type: _pageValuesCheck(pageContextValues.vehicle.type,'niceName'),
        webapp: '',
        usein: _handlePublicationState(_pageValuesCheck(pageContextValues.vehicle,'publicationState','new'))
    };

    $.extend(context, sectsGenerator({sect10: SECT10_FIND}), wtfContextGenerator());

    return context;
}

function _handlePublicationState(ps) {
    var _ps = ps.toLowerCase();
    if(_ps === 'new_used' || _ps === 'future') {
        _ps = 'new';
    }
    return _ps;
}

function _pageValuesCheck(page, value, fallback){
    if(page && page[value]){
        return page[value] + '';
    }
    return fallback || '';
}

/**
 * Class for getting page level (aka common aka global) targeting values.
 */
var AdContext = function() {
    var commonContext;

    /**
     * Context Values common to all ad units.
     *
     * @return {[type]} [description]
     */
    this.getCommonContext = function() {
        if(!commonContext) {
            commonContext = {};
            commonContext.pageContext = _pageContext();
            commonContext.visitorSpecific = _visitorContext();
            commonContext.siteName = sitenameGenerator(pageValues.values());
        }

        return commonContext;
    };

    /**
     * Preps new values.  Typically called before a retarget
     * @return {void}
     */
    this.markAsNewPage = function(){
        commonContext = null;
    };

    /**
     * Updates site name, for resizing.
     * @return {void}
     */
    this.changeDartSiteName = function(){
        commonContext && (commonContext.siteName = sitenameGenerator(pageValues.values()));
    };
};

module.exports = new AdContext();



//////////////////
// WEBPACK FOOTER
// ./src/interlock/product/ads/ad-context/ad-context.js
// module id = 200
// module chunks = 36